export default __webpack_public_path__ + "static/media/i002vp.25e07109.webp";